import BodySnippet from './BodySnippet';
import HeadSnippet from './HeadSnippet';
import {
    clearGtmUserData,
    reportGtmUserData,
} from './userData';
import {
    dataLayer,
    pushToDataLayer,
} from './utils';

const gtm = {
    dataLayer,
    pushToDataLayer,
};
export {
    BodySnippet,
    HeadSnippet,
    clearGtmUserData,
    gtm,
    reportGtmUserData,
};
